import { queryPayRes } from './../api/recharge';
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { getInfo } from "@/api/my";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "Index",
    redirect: "My",
  },
  {
    path: "/",
    name: "Index",
    redirect: "My",
  },
  {
    path: "/my", // 个人信息页
    name: "My",
    component: () => import("@/views/my/index.vue"),
  },
  {
    path: "/bind", // 绑定页
    name: "Bind",
    component: () => import("@/views/bind/index.vue"),
  },
  {
    path: "/visitor", // 入校预约--列表
    name: "Visitor",
    component: () => import("@/views/visitor/index.vue"),
  },
  {
    path: "/visitor/add", // 家长预约--新增
    name: "VisitorAdd",
    component: () => import("@/views/visitor/add.vue"),
  },
  {
    path: "/visitor/normal/park", // 普通预约--新增--园区
    name: "VisitorNormalPark",
    component: () => import("@/views/visitor/normal.vue"),
  },
  {
    path: "/visitor/normal/campus", // 普通预约--新增--校园
    name: "VisitorNormalCampus",
    component: () => import("@/views/visitor/normal.vue"),
  },
  {
    path: "/visitor/search", // 普通预约--搜索
    name: "VisitorSearch",
    component: () => import("@/views/visitor/search.vue"),
  },
  {
    path: "/leave", // 请假单管理--列表
    name: "Leave",
    component: () => import("@/views/leave/index.vue"),
  },
  {
    path: "/leave/add", // 请假单管理--新增
    name: "LeaveAdd",
    component: () => import("@/views/leave/add.vue"),
  },
  {
    path: "/leave", // 请假申请
    name: "Leave",
    component: () => import("@/views/leave/index.vue"),
  },
  {
    path: "/bind/switch", // 切换绑定账号
    name: "BindSwitch",
    component: () => import("@/views/bind/switch.vue"),
  },
  {
    path: "/consume/recharge", // 在线充值页
    name: "Recharge",
    component: () => import("@/views/consume/recharge/index.vue"),
  },
  {
    path: "/consume/recharge/success", // 充值成功页
    name: "RechargeSuccess",
    component: () => import("@/views/consume/recharge/success.vue"),
  },
  {
    path: "/consume/log", // 交易记录
    name: "ConsumeLog",
    component: () => import("@/views/consume/log/index.vue"),
  },
  {
    path: "/consume/limit", // 交易限制
    name: "ConsumeLimit",
    component: () => import("@/views/consume/limit/index.vue"),
  },
  {
    path: "/student", // 教职工人脸信息采集页
    name: "Student",
    component: () => import("@/views/addperson/student.vue"),
  },
  {
    path: "/teacher", // 学生人脸信息采集页
    name: "Teacher",
    component: () => import("@/views/addperson/teacher.vue"),
  },
  {
    path: "/addLock", // 锁具信息
    name: "AddLock",
    component: () => import("@/views/addLock/index.vue"),
  },
  {
    path: "/addLock/qr", // 扫码页面
    name: "Qr",
    component: () => import("@/views/addLock/qr.vue"),
  },
  {
    path: "/addLock/queryMac", // 查询门锁信息
    name: "queryMac",
    component: () => import("@/views/addLock/query.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
let nextPath = "/"; // 防止重复跳转到相同路径下
router.beforeEach((to, from, next) => {
  // 进入每个页面前调用此接口 判断personId是否存在 不存在表示用户未绑定 跳转绑定页面
  const token = to?.query?.accessToken ?? localStorage.getItem("token");
  localStorage.setItem("token", token + "");
  // console.log(to.path, nextPath, ["/student", "/teacher"].includes(to.path));
  // 无需校验的路由
  if (
    [
      "/student",
      "/teacher",
      "/Student",
      "/Teacher",
      "/visitor/normal/park",
      "/visitor/normal/campus",
      "/visitor/search",
      "/addLock",
      "/addLock/qr",
      "/addLock/queryMac"
    ].includes(to.path)
  ) {
    next();
  } else {
    if (!token || to.path === nextPath) {
      next();
    } else {
      getInfo()
        .then(({ code, data }) => {
          if (!data?.personId) {
            nextPath = to.path;
            next("/bind");
            // next({ ...to, path: "/bind" });
          } else {
            localStorage.setItem("userInfo", JSON.stringify(data));
            nextPath = to.path;
            next();
          }
        })
        .catch(() => {
          nextPath = to.path;
          next({ path: "/" });
        });
    }
  }
});

export default router;
